import { render, staticRenderFns } from "./TermsAndConditionsTag.vue?vue&type=template&id=b09a972c&scoped=true"
import script from "./TermsAndConditionsTag.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsTag.vue?vue&type=script&lang=js"
import style0 from "./TermsAndConditionsTag.vue?vue&type=style&index=0&id=b09a972c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09a972c",
  null
  
)

export default component.exports